// extracted by mini-css-extract-plugin
export default {"userPanel":"UserPanel_userPanel__3M6lC","userAvatar":"UserPanel_userAvatar__DeCI8","userRoleText":"UserPanel_userRoleText__A311e"};